import {defineSlotRecipe} from '@chakra-ui/react3'

export const recaptchaSlotRecipe = defineSlotRecipe({
    className: 'recaptcha',
    slots: ['attribution', 'widget'],

    base: {
        attribution: {
            color: 'text.secondary',
            textStyle: 'body.xsmall'
        },
        // Google allows hiding the badge only while the attribution text is shown instead
        widget: {
            position: 'absolute',
            height: 0,
            overflow: 'hidden',
            '& .grecaptcha-badge': {
                visibility: 'hidden'
            }
        }
    }
})
